import styled, { css } from 'styled-components/macro';

export const StyledToast = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.base};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.base};
    min-width: 400px;
    background-color: ${theme.semantic.bg.inverse};
    border-radius: ${theme.radiuses.base};
    box-shadow: ${theme.shadows.xs};
    color: ${theme.semantic.text.onInverse};
  `};
`;
